/* THIS FILE WAS AUTO GENERATED. DO NOT EDIT THIS FILE MANUALLY */
/* CREATED BY: ./scripts/createExposeComponents.js */

import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import './scss/style.scss';

import Company_CompanyCompareChoose from './entrypoints/Company/CompanyCompareChoose';
import Company_CompanyComparePage from './entrypoints/Company/CompanyComparePage';
import Company_CompanyConstructionPage from './entrypoints/Company/CompanyConstructionPage';
import Company_CompanyLegalPage from './entrypoints/Company/CompanyLegalPage';
import Company_CompanyMembersPage from './entrypoints/Company/CompanyMembersPage';
import Company_CompanyPapersPage from './entrypoints/Company/CompanyPapersPage';
import Company_CompanyPropertiesPage from './entrypoints/Company/CompanyPropertiesPage';
import Company_CompanyReportsPage from './entrypoints/Company/CompanyReportsPage';
import Company_CompanyStatementsPage from './entrypoints/Company/CompanyStatementsPage';
import Company_CompanyVehiclesPage from './entrypoints/Company/CompanyVehiclesPage';
import Company_Search from './entrypoints/Company/Search';
import Company_TestProfile from './entrypoints/Company/TestProfile';
import Company_Valuation from './entrypoints/Company/Valuation';
import Company_ViewCompanyComparePage from './entrypoints/Company/ViewCompanyComparePage';
import Company_ViewCompanyReport from './entrypoints/Company/ViewCompanyReport';
import Company_ViewConstructionsReport from './entrypoints/Company/ViewConstructionsReport';
import Company_ViewMemberReport from './entrypoints/Company/ViewMemberReport';
import Company_ViewPropertiesReport from './entrypoints/Company/ViewPropertiesReport';
import Company_ViewVehiclesReport from './entrypoints/Company/ViewVehiclesReport';
import Debug_Hlutabref from './entrypoints/Debug/Hlutabref';
import Debug_Sjodir from './entrypoints/Debug/Sjodir';
import Entrypoint from './entrypoints/Entrypoint';
import Home_About from './entrypoints/Home/About';
import Home_Advertise from './entrypoints/Home/Advertise';
import Home_Calendar from './entrypoints/Home/Calendar';
import Home_Contact from './entrypoints/Home/Contact';
import Home_DueDiligence from './entrypoints/Home/DueDiligence';
import Home_ErrorPage from './entrypoints/Home/ErrorPage';
import Home_HomePage from './entrypoints/Home/HomePage';
import Home_Login from './entrypoints/Home/Login';
import Home_LostPassword from './entrypoints/Home/LostPassword';
import Home_NewsWatch from './entrypoints/Home/NewsWatch';
import Home_PricingPage from './entrypoints/Home/PricingPage';
import Home_Search from './entrypoints/Home/Search';
import Home_SignUp from './entrypoints/Home/SignUp';
import Home_SingleNewsPage from './entrypoints/Home/SingleNewsPage';
import Home_Stillingar from './entrypoints/Home/Stillingar';
import Home_SubscriptionPage from './entrypoints/Home/SubscriptionPage';
import Home_UserDisclaimer from './entrypoints/Home/UserDisclaimer';
import Home_WebService from './entrypoints/Home/WebService';
import Individual_MembershipSearch from './entrypoints/Individual/MembershipSearch';
import Individual_Profile from './entrypoints/Individual/Profile';
import Individual_Search from './entrypoints/Individual/Search';
import Individual_ViewMembership from './entrypoints/Individual/ViewMembership';
import Individual_ViewPropertiesReport from './entrypoints/Individual/ViewPropertiesReport';
import Individual_ViewVehiclesReport from './entrypoints/Individual/ViewVehiclesReport';
import KeldanApp_About from './entrypoints/KeldanApp/About';
import KeldanApp_Disclaimer from './entrypoints/KeldanApp/Disclaimer';
import KeldanApp_SignUp from './entrypoints/KeldanApp/SignUp';
import Layout_Alert from './entrypoints/Layout/Alert';
import Layout_CookieConsentForm from './entrypoints/Layout/CookieConsentForm';
import Layout_Footer from './entrypoints/Layout/Footer';
import Layout_Header from './entrypoints/Layout/Header';
import Legal_LegalSearch from './entrypoints/Legal/LegalSearch';
import Lists_ExcellentCompanies from './entrypoints/Lists/ExcellentCompanies';
import Lists_ExcellentList from './entrypoints/Lists/ExcellentList';
import Lists_ListarAlmennt from './entrypoints/Lists/ListarAlmennt';
import Lists_ListarAlmenntAllt from './entrypoints/Lists/ListarAlmenntAllt';
import Lists_Markhopalistar from './entrypoints/Lists/Markhopalistar';
import Lists_Serpontun from './entrypoints/Lists/Serpontun';
import Market_Bonds from './entrypoints/Market/Bonds';
import Market_Currencies from './entrypoints/Market/Currencies';
import Market_FinanceRef from './entrypoints/Market/FinanceRef';
import Market_Funds from './entrypoints/Market/Funds';
import Market_FXMarket from './entrypoints/Market/FXMarket';
import Market_GEMMAQ from './entrypoints/Market/GEMMAQ';
import Market_Indices from './entrypoints/Market/Indices';
import Market_OrderGEMMAQ from './entrypoints/Market/OrderGEMMAQ';
import Market_PublishGEMMAQ from './entrypoints/Market/PublishGEMMAQ';
import Market_Shares from './entrypoints/Market/Shares';
import Market_SingleBond from './entrypoints/Market/SingleBond';
import Market_SingleFund from './entrypoints/Market/SingleFund';
import Market_SingleIndex from './entrypoints/Market/SingleIndex';
import Market_SingleShare from './entrypoints/Market/SingleShare';
import Market_SpecialFunds from './entrypoints/Market/SpecialFunds';
import MyKelda_Invoices from './entrypoints/MyKelda/Invoices';
import MyKelda_Reports from './entrypoints/MyKelda/Reports';
import MyKelda_ReportsSub from './entrypoints/MyKelda/ReportsSub';
import MyKelda_Watch from './entrypoints/MyKelda/Watch';
import PEP_Search from './entrypoints/PEP/Search';
import PEP_ViewReport from './entrypoints/PEP/ViewReport';
import Property_Gangverd from './entrypoints/Property/Gangverd';
import Property_GangverdReport from './entrypoints/Property/GangverdReport';
import Property_Profile from './entrypoints/Property/Profile';
import Property_PropertySearches from './entrypoints/Property/PropertySearches';
import Property_PurchaseAgreements from './entrypoints/Property/PurchaseAgreements';
import Property_RentAgreements from './entrypoints/Property/RentAgreements';
import Property_Reports from './entrypoints/Property/Reports';
import Property_ViewOverview from './entrypoints/Property/ViewOverview';
import Property_ViewReport from './entrypoints/Property/ViewReport';
import Vaktarinn_Vaktarinn from './entrypoints/Vaktarinn/Vaktarinn';
import Vehicle_Search from './entrypoints/Vehicle/Search';
import Vehicle_ViewConstructionProfile from './entrypoints/Vehicle/ViewConstructionProfile';
import Vehicle_ViewVehicleProfilePage from './entrypoints/Vehicle/ViewVehicleProfilePage';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

// @ts-ignore
global.ReactComponents = {
Company: {
CompanyCompareChoose: Company_CompanyCompareChoose,
CompanyComparePage: Company_CompanyComparePage,
CompanyConstructionPage: Company_CompanyConstructionPage,
CompanyLegalPage: Company_CompanyLegalPage,
CompanyMembersPage: Company_CompanyMembersPage,
CompanyPapersPage: Company_CompanyPapersPage,
CompanyPropertiesPage: Company_CompanyPropertiesPage,
CompanyReportsPage: Company_CompanyReportsPage,
CompanyStatementsPage: Company_CompanyStatementsPage,
CompanyVehiclesPage: Company_CompanyVehiclesPage,
Search: Company_Search,
TestProfile: Company_TestProfile,
Valuation: Company_Valuation,
ViewCompanyComparePage: Company_ViewCompanyComparePage,
ViewCompanyReport: Company_ViewCompanyReport,
ViewConstructionsReport: Company_ViewConstructionsReport,
ViewMemberReport: Company_ViewMemberReport,
ViewPropertiesReport: Company_ViewPropertiesReport,
ViewVehiclesReport: Company_ViewVehiclesReport,
},
Debug: {
Hlutabref: Debug_Hlutabref,
Sjodir: Debug_Sjodir,
},
Entrypoint: {
undefined: Entrypoint,
},
Home: {
About: Home_About,
Advertise: Home_Advertise,
Calendar: Home_Calendar,
Contact: Home_Contact,
DueDiligence: Home_DueDiligence,
ErrorPage: Home_ErrorPage,
HomePage: Home_HomePage,
Login: Home_Login,
LostPassword: Home_LostPassword,
NewsWatch: Home_NewsWatch,
PricingPage: Home_PricingPage,
Search: Home_Search,
SignUp: Home_SignUp,
SingleNewsPage: Home_SingleNewsPage,
Stillingar: Home_Stillingar,
SubscriptionPage: Home_SubscriptionPage,
UserDisclaimer: Home_UserDisclaimer,
WebService: Home_WebService,
},
Individual: {
MembershipSearch: Individual_MembershipSearch,
Profile: Individual_Profile,
Search: Individual_Search,
ViewMembership: Individual_ViewMembership,
ViewPropertiesReport: Individual_ViewPropertiesReport,
ViewVehiclesReport: Individual_ViewVehiclesReport,
},
KeldanApp: {
About: KeldanApp_About,
Disclaimer: KeldanApp_Disclaimer,
SignUp: KeldanApp_SignUp,
},
Layout: {
Alert: Layout_Alert,
CookieConsentForm: Layout_CookieConsentForm,
Footer: Layout_Footer,
Header: Layout_Header,
},
Legal: {
LegalSearch: Legal_LegalSearch,
},
Lists: {
ExcellentCompanies: Lists_ExcellentCompanies,
ExcellentList: Lists_ExcellentList,
ListarAlmennt: Lists_ListarAlmennt,
ListarAlmenntAllt: Lists_ListarAlmenntAllt,
Markhopalistar: Lists_Markhopalistar,
Serpontun: Lists_Serpontun,
},
Market: {
Bonds: Market_Bonds,
Currencies: Market_Currencies,
FinanceRef: Market_FinanceRef,
Funds: Market_Funds,
FXMarket: Market_FXMarket,
GEMMAQ: Market_GEMMAQ,
Indices: Market_Indices,
OrderGEMMAQ: Market_OrderGEMMAQ,
PublishGEMMAQ: Market_PublishGEMMAQ,
Shares: Market_Shares,
SingleBond: Market_SingleBond,
SingleFund: Market_SingleFund,
SingleIndex: Market_SingleIndex,
SingleShare: Market_SingleShare,
SpecialFunds: Market_SpecialFunds,
},
MyKelda: {
Invoices: MyKelda_Invoices,
Reports: MyKelda_Reports,
ReportsSub: MyKelda_ReportsSub,
Watch: MyKelda_Watch,
},
PEP: {
Search: PEP_Search,
ViewReport: PEP_ViewReport,
},
Property: {
Gangverd: Property_Gangverd,
GangverdReport: Property_GangverdReport,
Profile: Property_Profile,
PropertySearches: Property_PropertySearches,
PurchaseAgreements: Property_PurchaseAgreements,
RentAgreements: Property_RentAgreements,
Reports: Property_Reports,
ViewOverview: Property_ViewOverview,
ViewReport: Property_ViewReport,
},
Vaktarinn: {
Vaktarinn: Vaktarinn_Vaktarinn,
},
Vehicle: {
Search: Vehicle_Search,
ViewConstructionProfile: Vehicle_ViewConstructionProfile,
ViewVehicleProfilePage: Vehicle_ViewVehicleProfilePage,
},
};
